export const GET_F2W_SETTINGS_SUCCESS = 'GET_TPP_SETTINGS_SUCCESS';
